module.exports = __webpack_public_path__ + "img/create-image-event.16e689ca.svg";